module.exports = __webpack_public_path__ + "img/Green-Hill-Zone.0207b4fa.png";